<template>
  <div class="page-wrapper" style="overflow-y: scroll;">
    <div class="container" style="padding-bottom: 100px;">
      <div class="row">
        <div class="col-12 section-header">
          관리자 리스트 <button class="btn btn-primary" @click="editUserItem(0)">추가</button>
        </div>
        <div class="col-12 text-left">

          <table class="table">
            <tr><th>이름</th><th>Email</th><th>Role</th><th>이사담당</th><th>특송담당</th><ht/></tr>
            <tbody>
              <tr v-for="user in users">
                <td>{{user.name}}</td>
                <td>{{user.email}}</td>
                <td>{{user.type}}</td>
                <td><span class="admin-unchecked" v-bind:class="{'admin-checked': isUserMoveAdmin(user.id) == true}" v-on:click="toggleMoveUserMeta(user.id)"><i class="fas fa-check"></i></span></td>
                <td><span class="admin-unchecked" v-bind:class="{'admin-checked': isUserExpressAdmin(user.id) == true}" v-on:click="toggleExpressUserMeta(user.id)"><i class="fas fa-check"></i></span></td>
                <td><button class="btn btn-success" @click="editUserItem(user.id)">Edit</button></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="row" v-if="agent != false">
        <div class="col-6 section-header">
          Company Details (Shipper)
        </div>
        <div class="col-6 section-header text-right">
          <button v-if="agent.edit == false" class="btn btn-success" v-on:click="agent.edit = true"><i class="fas fa-edit"></i> EDIT</button>
          <button v-if="agent.edit == true" class="btn btn-dark" v-on:click="agent.edit = false"><i class="fas fa-times"></i> CANCEL</button>
        </div>
      </div>
      <div class="row input-row text-left">
        <div class="col-12">
          <table class="form-table" style="width:100%;">
            <tr class="form-table-row">
              <td style="width: 300px;">Title</td>
              <td style="width: calc(100% - 300px);"><input type="text" class="form-control" v-model="agent.title" placeholder="Title" :disabled="agent.edit==false"/></td>
            </tr>
            <tr>
              <td>Description</td>
              <td><input type="text" class="form-control" v-model="agent.description" placeholder="Description" :disabled="agent.edit==false"/></td>
            </tr>
            <tr>
              <td>Address</td>
              <td>
                <input type="text" class="form-control" v-model="agent.address1" placeholder="Line 1" :disabled="agent.edit==false"/>
                <input type="text" class="form-control" v-model="agent.address2" placeholder="Line 2" :disabled="agent.edit==false"/>
                <input type="text" class="form-control" v-model="agent.address3" placeholder="Line 3" :disabled="agent.edit==false"/>
                <input type="text" class="form-control" v-model="agent.postCode" placeholder="POST CODE" :disabled="agent.edit==false"/>
                <input type="text" class="form-control" v-model="agent.country" placeholder="Country" :disabled="agent.edit==false"/>
              </td>
            </tr>
            <tr>
              <td>Carrier City (Airway Bill)</td>
              <td><input type="text" class="form-control" v-model="agent.city" placeholder="City" :disabled="agent.edit==false"/></td>
            </tr>
            <tr>
              <td>Email</td>
              <td>
                <input type="text" class="form-control" v-model="agent.email" placeholder="Email" :disabled="agent.edit==false"/>
              </td>
            </tr>
            <tr>
              <td>Telephone</td>
              <td>
                <input type="text" class="form-control" v-model="agent.telephone" placeholder="Telephone" :disabled="agent.edit==false"/>
              </td>
            </tr>
            <tr>
              <td>FAX</td>
              <td>
                <input type="text" class="form-control" v-model="agent.fax" placeholder="Fax" :disabled="agent.edit==false"/>
              </td>
            </tr>
            <tr>
              <td>IATA Code</td>
              <td>
                <input type="text" class="form-control" v-model="agent.iataCode" placeholder="IATA Code" :disabled="agent.edit==false"/>
              </td>
            </tr>
          </table>
        </div>

      </div>
      <div class="row">
        <div class="col-12 text-right">
          <button v-if="agent.edit == true" class="btn btn-primary" v-on:click="saveCompanyInfo"><i class="fas fa-save"></i> SAVE</button>
        </div>
      </div>
      <div class="row">
        <div class="col-12 section-header">
          고객용 문서
        </div>
        <div class="col-12">
          <table style="width: 100%;">
            <tr>
              <th>제목</th>
              <th>설명</th>

              <th></th>
<!--              <th></th>-->
            </tr>
            <tbody v-for="(doc, di) in documents" :key="'doc-row-' + doc.id" style="padding-top: 10px;">
            <tr>
              <td style="width: 300px;"><input v-model="doc.title" class="form-control" @change="updateDocument(di)"/></td>
              <td>
                <input v-model="doc.description" class="form-control" @change="updateDocument(di)"/>

              </td>
              <td><button class="btn btn-danger" @change="deleteDocument(di)"><i class="fas fa-trash"></i></button></td>
            </tr>
            <tr style="border-bottom: 1px solid #dadada;">
              <td></td>
              <td colspan="2" style=" padding-bottom: 20px; text-align: left;">
                <button v-if="doc.url != null && doc.url.length > 0" class="btn btn-success" @click="openDocument(doc.url)">View File</button>
                <button class="btn btn-warning" @click="onDocumentUploadClicked('docFile' + di)">Upload File</button>

<!--                <progress value="0" max="100" :id="'uploader-' + di"></progress>-->
                <input accept="file" type="file" :id="'docFile' + di" value="upload" style="display: none;" @change="fileSelected($event, di)">
<!--                <button class="btn btn-primary"><i class="fas fa-upload"></i></button>-->
              </td>

            </tr>
            </tbody>

            <tr>
              <td colspan="4" class="text-left">
                <button class="btn btn-success" @click="addNewDocument"><i class="fas fa-plus"></i></button>
              </td>
            </tr>
          </table>
        </div>
      </div>

      <div class="row">
        <div class="col-12 section-header">
          품목 리스트 (App에서 클릭으로 물품 추가위한 리스트)
        </div>
        <div class="col-12" style="display: inline-block;">
          <div style="padding:10px; margin:10px; border:1px solid grey; float: left; border-radius: 5px; box-shadow: 3px 3px 5px grey;" v-for="(item, ii) in exampleItems">{{item.title}} &nbsp;&nbsp;&nbsp;<i class="fas fa-trash" @click="removeExampleItem(ii)"></i></div>
        </div>
        <div class="col-12">
          <input type="text" v-model="newExampleItemTitle" class="form-control" @change="addNewExampleItem" placeholder="새로운 아이템 이름 입력후 엔터키"/>
        </div>
      </div>

      <div class="row">
        <div class="col-12 section-header">
          물품 위치
        </div>
        <div class="col-12">
          <table class="table">
            <tr>
              <th style="width: 300px;">이름</th>
              <th>물품</th>
              <th style="max-width: 150px;">No of Rows in Survey Form</th>
              <th></th>
            </tr>
            <draggable v-model="locations" tag="tbody" @change="updateLocationOrder">
            <tr v-for="(loc, li) in locations">
              <td><input v-model="loc.title" class="form-control" @change="updateLocationItem(li)"/></td>
              <td>
                <div style="width: 100%; padding:5px; display: inline-block;">
                  <div style="float: left; padding: 5px; border: 1px solid gray; border-radius: 5px; margin-right: 5px; margin-bottom: 5px;" v-for="tag in loc.tags">
                    {{tag}} <span v-on:click="removeLocationGood(li, tag)"><i class="fas fa-trash"></i></span>
                  </div>
                </div>
                <div style="width: 100%; display: flex;">
                  <div style="width: calc(100% - 30px);">
                    <input type="text" class="form-control" :id="'location-goods-input-'+ li" @change="addLocationGood(li)"/>
                  </div>
                  <div style="width: 30px; height: 30px;" @click="addLocationGood(li)"><i class="fas fa-plus"></i></div>
                </div>


              </td>
              <td>
                <select v-model="loc.amount" class="form-control" @change="updateLocationItem(li)">
                  <option v-for="c in 50" :value="c">{{c}}</option>
                </select>
              </td>

              <td><button class="btn btn-danger" @change="deleteLocationItem(li)"><i class="fas fa-trash"></i></button></td>
            </tr>
            </draggable>
            <tr>
              <td colspan="2" class="text-left">
                <button class="btn btn-success" @click="addNewLocationItem"><i class="fas fa-plus"></i></button>
              </td>
            </tr>

          </table>
        </div>
      </div>

      <div class="row">
        <div class="col-12 section-header">
          준비 물품 리스트
        </div>
        <div class="col-12">
          <table class="table">
            <tr>
              <th>이름</th>
              <th>Min 수량</th>
              <th>Max 수량</th>
              <th>단위</th>
              <th></th>
            </tr>
            <draggable v-model="preparations" tag="tbody" @change="updatePrepOrder">
              <tr v-for="(prep, li) in preparations">
                <td><input v-model="prep.title" class="form-control" @change="updatePrepItem(li)"/></td>
                <td><input v-model="prep.min" class="form-control" @change="updatePrepItem(li)"/></td>
                <td><input v-model="prep.max" class="form-control" @change="updatePrepItem(li)"/></td>
                <td><input v-model="prep.gap" class="form-control" @change="updatePrepItem(li)"/></td>
                <td><button class="btn btn-danger" @change="deletePrepItem(li)"><i class="fas fa-trash"></i></button></td>
              </tr>
            </draggable>
            <tr>
              <td colspan="2" class="text-left">
                <button class="btn btn-success" @click="addNewPrepItem"><i class="fas fa-plus"></i></button>
              </td>
            </tr>

          </table>
        </div>
      </div>
      <div class="row">
        <div class="col-12 section-header">
          특송가격
        </div>

      </div>
      <div class="row border-top">
        <div class="col-4">
          <strong>기본요금</strong>
        </div>
        <div class="col-4">
          기본무게 (g)
          <input type="number" class="form-control" v-model="expressBasicPrice.val" @change="updateExpBasicMeta"/>
        </div>
        <div class="col-4">
          기본가격 (pence)
          <input type="number" class="form-control" v-model="expressBasicPrice.val2" @change="updateExpBasicMeta"/>
        </div>

      </div>
      <div class="row border-top" style="padding-top:10px;margin-top: 10px;">
        <div class="col-4">
          <strong>추가요금</strong>
        </div>
        <div class="col-4">
          무게 (g)
          <input type="number" class="form-control" v-model="expressAddPrice.val" @change="updateExpAddMeta"/>
        </div>
        <div class="col-4">
          가격
          <input type="number" class="form-control" v-model="expressAddPrice.val2" @change="updateExpAddMeta"/>
        </div>

        </div>

    </div>


    <transition name="slideup">
      <div class="center-form-background" v-if="editUser != false">
        <div class="center-form-container">
          <div class="container">
            <div class="row">
              <div class="col-12 form-header">
                Edit User
              </div>
            </div>
            <div class="row form-item-container">
              <div class="col-12">
                <input type="text" class="form-control" v-model="editUser.email" placeholder="User ID (Only lowercase, No Space or Special character)"/>
              </div>
              <div class="col-12">
                <input type="text" class="form-control" v-model="editUser.name" placeholder="Name"/>
              </div>
              <div class="col-12">
                <input type="text" class="form-control" v-model="editUser.password" placeholder="Password"/>
              </div>
              <div class="col-12">
                <input type="text" class="form-control" v-model="editUser.password2" placeholder="Confirm Password"/>
              </div>
              <div class="col-12">
                <select class="form-control" v-model="editUser.type">
                  <option v-for="level in userLevel" :value="level.type">{{level.title}}</option>
                </select>
              </div>
            </div>
            <div class="row" style="padding-top: 10px;">
              <div class="col-4">
                <button class="btn btn-secondary form-control" v-on:click="editUser = false">Cancel</button>
              </div>
              <div class="col-4">
                <button class="btn btn-danger form-controler" @click="deleteUser(editUser)">DELETE</button>
              </div>
              <div class="col-4">
                <button class="btn btn-primary form-control" v-on:click="submitEditUser"><span v-if="editUser.id == 0">Create</span><span v-else>Update</span></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <v-dialog width="500"/>
    <transition name="dissolve">
      <div class="progressView" v-if="isLoading==true">
        <div class="center-container">
          <div class="content-center">
            <img src="/static/img/beible-logo-black.png" width="300px" class="bounce-anim"/>
            <p class="loading-message"> {{loadingMessage}}</p>
          </div>

        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  import {createNewDocument, deleteDocument, getDocuments, getDocumentTypeList, updateDocument} from "../api/documents";

  require('@/assets/css/styles.css')
    var XLSX = require('xlsx');
    import {getMetasByType, getMetaByType, updateMetaItem, deleteMeta} from "../api/meta";
  import {
    addUser,
    getUserList,
    createUsers,
    updateUser,
    createNewUser,
    getUser,
    getStaffList,
    deleteUser
  } from "../api/user";
    import {getProductById} from "../api/product";
  import {generateOrderNumber, showDialog} from "../api/utils";
    import {placeOrder} from "../api/order";
    import ImageInput from "./ImageInput";
    import draggable from 'vuedraggable';
    import moment from 'moment';

  import * as firebase from "firebase/app";
  // Add the Firebase services that you want to use
  import "firebase/auth";
  import "firebase/storage";
  import {createNewGoodItem, deleteGood, getGoods, updateGood, updateGoods} from "../api/goods";
  import {getDefaultList, getDefaultSettings} from "../api/settings";
  import {getMainAgent, updateAgent} from "../api/agents";
  import EventBus from "../api/event-bus";

    export default {
        name: "Setting",
        data() {
          return {
            orderTypes:[],
            orderTypeItem:false,
            minOrderPrice:false,
            minOrderAmount:false,
            frontPage:false,
            fromPageItem:false,
            newTag: {
                tag:'',
                name:'',
            },
            state: {
                tickets: [{name: "test"}],
                headers: ["Test header"]
            },
            users:[],
            moveAdmins:[],
            expressAdmins:[],
            isLoading: false,
            loadingMessage: '',

            expressBasicPrice: {
              id:0,
              type:'exp_base_price',
              val: 0,
              val2: 0
            },
            expressAddPrice:{
              id:0,
              type:'exp_add_price',
              val: 0,
              val2: 0
            },
            documentTypes:getDocumentTypeList(),
            documents:[],
            exampleItems:[],
            newExampleItemTitle:'',
            locations:[],
            preparations:[],
            editUser:false,
            userLevel: [
              {
                value:'admin',
                title:'Admin',
                type:'ROLE_ADMIN',
              },
              {
                value:'manager',
                title:'Manager',
                type:'ROLE_MANAGER',
              },
              {
                value:'staff',
                title:'Staff',
                type:'ROLE_STAFF',
              },
              // {
              //   value:'merchant',
              //   title:'Merchant',
              //   type:'ROLE_MERCHANT',
              // },
              // {
              //   value:'driver',
              //   title:'Driver',
              //   type:'ROLE_DRIVER',
              // }

            ],
            settings:getDefaultSettings(),
            agent:false,
          }
        },
        components: {
            ImageInput,
            draggable,
        },
        created() {
            // this.getProductOptionList();
        },
        mounted() {
            this.getUserList();
        },
        methods: {
            showModal: function(title, message) {
                console.log("show modal " + title  + " : " + message);
                this.$modal.show('dialog',{
                    title: title,
                    text: message,
                    buttons:[
                        {title:'Close'}
                    ]
                })
                return;
            },

            getUserList: function() {
                let self = this;
                getStaffList('all')
                    .then(function(data) {
                        if(data.success == true) {
                            self.$data.users = data.item;
                        }
                    })
                    .catch(function(err) {

                    })
              this.getUserMetaList();
              this.getExpMetaList();
              this.populateDocuments();
              this.getExampleItems();
              this.getLocationItems();
              this.getPrepItems();
              this.getCompanyInfo();
            },

            resetPassword: function(user) {
                let userItem = {
                    id: user.id,
                    password:'uko1234',
                };
                let self = this;
                this.$data.isLoading = true;
                updateUser(userItem)
                    .then(function(data){
                        self.$data.isLoading = false;
                        if(data.success == true) {
                            self.showModal("", data.item.email + "회원 비밀번호가 uko1234로 재설정 되었습니다.");

                        } else {
                            self.showModal("", "업데이트 실페 했습니다. " + data.message);
                        }
                    })
                    .catch(function(err){
                        self.$data.isLoading = false;
                        let message = err;
                        if(err.response != undefined) {
                            message += " : " + err.response;
                        }
                        self.showModal("", "에러가 발생했습니다. " + message);
                    })
            },

            getExpMetaList: function() {
              let self = this;
              getMetaByType('exp_base_price')
                .then(function(data) {
                  if(data.success == true) {
                    self.$data.expressBasicPrice = data.item;
                  }
                })
                .catch(function(err) {

                })
              getMetaByType('exp_add_price')
                .then(function(data) {
                  if(data.success == true) {
                    self.$data.expressAddPrice = data.item;
                  }
                })
                .catch(function(err) {

                })
            },
            updateExpBasicMeta: function() {
              let self = this;
              updateMetaItem(this.$data.expressBasicPrice)
              .then(function(data) {
                if(data.success == true) {
                  self.$data.expressBasicPrice = data.item;
                } else {
                  window.alert("Failed to update " + data.message);
                }
              })
              .catch(function(err) {
                window.alert("Error at updating Base Price " + err)
              })
            },
            updateExpAddMeta: function() {
              let self = this;
              updateMetaItem(this.$data.expressAddPrice)
                .then(function(data) {
                  if(data.success == true) {
                    self.$data.expressAddPrice = data.item;
                  } else {
                    window.alert("Failed to update " + data.message);
                  }
                })
                .catch(function(err) {
                  window.alert("Error at updating Add Price " + err)
                })
            },

            getUserMetaList: function() {
              this.getMoveUserMetas();
              this.getExpressUserMetas();
            },
            getMoveUserMetas: function() {
              let self = this;
              getMetasByType('move_admin')
              .then(function(data) {
                if(data.success) {
                  self.$data.moveAdmins = data.item;
                  console.log("move admin list");
                  console.log(self.$data.moveAdmins);
                } else {
                  console.log("No Move Admin list");
                }
              })
              .catch(function(err) {

              })
            },
            getExpressUserMetas: function() {
              let self = this;
              getMetasByType('express_admin')
                .then(function(data) {
                  if(data.success) {
                    self.$data.expressAdmins = data.item;
                  }
                })
                .catch(function(err) {

                })
            },
            isUserMoveAdmin: function(userId) {
              for(let i = 0 ; i < this.$data.moveAdmins.length ; i++) {
                if (this.$data.moveAdmins[i].userId == userId) {
                  return true;
                }
              }
              return false;
            },
          isUserExpressAdmin: function(userId) {
            for(let i = 0 ; i < this.$data.expressAdmins.length ; i++) {
              if (this.$data.expressAdmins[i].userId == userId) {
                return true;
              }
            }
            return false;
          },
          toggleMoveUserMeta: function(userId) {
            let self = this;
            console.log("toggleMoveUserMeta " + userId);
            for(let i = 0 ; i < this.$data.moveAdmins.length ; i++) {
              if(this.$data.moveAdmins[i].userId == userId) {
                // Remove
                console.log("remove move admin meta " + this.$data.moveAdmins[i].id);
                deleteMeta(this.$data.moveAdmins[i].id)
                .then(function(data) {
                  if(data.success == true) {

                  }
                })
                this.$data.moveAdmins.splice(i, 1);
                return;
              }
            }

            console.log('toggleMoveUserMeta no existing list');
            let newMeta = {
              id:0,
              type:'move_admin',
              userId: userId
            };

            updateMetaItem(newMeta)
            .then(function(data) {
              if(data.success == true) {
                self.$data.moveAdmins.push(data.item);
              }
            })
            .catch(function(err) {

            })
          },
          toggleExpressUserMeta: function(userId) {
            let self = this;
            for(let i = 0 ; i < this.$data.expressAdmins.length ; i++) {
              if(this.$data.expressAdmins[i].userId == userId) {
                // Remove
                deleteMeta(this.$data.expressAdmins[i].id)
                  .then(function(data) {
                    if(data.success == true) {

                    }
                  })
                this.$data.expressAdmins.splice(i, 1);
                return;
              }
            }

            let newMeta = {
              id:0,
              type:'express_admin',
              userId: userId
            };

            updateMetaItem(newMeta)
              .then(function(data) {
                if(data.success == true) {
                  self.$data.expressAdmins.push(data.item);
                }
              })
              .catch(function(err) {

              })
          },
          populateDocuments: function() {
            let self = this;

            getDocuments(0, 'info_document')
            .then(function(data) {
              if(data.success == true) {
                self.$data.documents = data.item;
              }
            })
            .catch(function(err) {

            })
          },
          fileSelected: function(e, index) {
            // const uploader = document.getElementById('uploader-' + index);
            //get file
            EventBus.$emit("showLoading", true);
            console.log("File Btn Added");
            console.log(e);
            let getFile = e.target.files[0];
            console.log("File name - " + getFile.name);
            //set storage ref
            let d = new Date();
            let name  = moment(d).format('YYYYMMDD-hhmmss');
            let names = getFile.name.split('.');

            let path = 'info-document/'  + this.documents[index].id + '-' + name + '-' + names[names.length-2] + '.' + names[names.length-1];
            let storageRef = firebase.storage().ref();
            let mountainsRef = storageRef.child(path);
            let self = this;
            mountainsRef.put(getFile).on('state_changed',
              function progress(snapshot){

                let percentage = (snapshot.bytesTransferred / snapshot.totalBytes) *100;
                console.log("percentage " + percentage);
                // uploader.value = percentage;
              },
              function error(err){
                EventBus.$emit("showLoading", false);
                console.log(err);
              },
              function complete(){
                EventBus.$emit("showLoading", false);
                console.log('complete upload');
                self.$data.documents[index].url = 'https://storage.googleapis.com/uko-projects.appspot.com/' + path;
                self.updateDocument(index);
              }
            );
          },
          updateDocument: function(index) {
            if(this.$data.documents[index].title == null || this.$data.documents[index].title.length == 0) {
              return;
            }

            let self = this;
            updateDocument(this.$data.documents[index])
            .then(function(data) {
              if(data.success == true) {
                self.$data.documents.splice(index, 1, data.item);
              } else {

              }
            })
            .catch(function(err) {

            })
          },
          deleteDocument: function(index) {
            if(this.$data.documents[index].id == 0) {
              this.$data.documents.splice(index, 1);
              return;
            }

            let self = this;
            deleteDocument(this.$data.documents[index].id)
              .then(function(data) {
                if(data.success == true) {
                  self.$data.documents.splice(index, 1);
                } else {

                }
              })
              .catch(function(err) {

              })
          },
          addNewDocument: function() {
            let newDocument = createNewDocument(0, 'info_document');
            this.$data.documents.push(newDocument);
          },
          getExampleItems: function() {
              let self = this;
            getGoods('item_example')
            .then(function(data) {
              if(data.success == true) {
                self.$data.exampleItems = data.item;
              }
            })
            .catch(function(err) {

            })
          },

          removeExampleItem: function(index) {
            if(this.$data.exampleItems[index].id == 0) {
              this.$data.exampleItems.splice(index, 1);
            }

            let self = this;
            deleteGood(this.$data.exampleItems[index].id)
            .then(function(data) {
              if(data.success == true) {
                self.$data.exampleItems.splice(index, 1);
              } else {
                showDialog(data.message);
              }
            })
            .catch(function(err) {
              let msg = err;
              if(err.response != undefined) {
                msg += ' (' + err.response + ')';
              }
              showDialog(msg);
            })


          },
          addNewExampleItem: function() {
              if(this.$data.newExampleItemTitle == null && this.$data.newExampleItemTitle.length <= 3) {
                showDialog("3글자 이상 입력해주세요");
                return;
              }

              for(let i = 0 ; i < this.$data.exampleItems.length ; i++) {
                if(this.$data.exampleItems[i].title.toLowerCase() === this.$data.newExampleItemTitle.toLowerCase().trim()) {
                  showDialog(this.$data.newExampleItemTitle + " 이미 있습니다.");
                  return;
                }
              }

              let newItem = createNewGoodItem(0, "item_example");
              newItem.title = this.$data.newExampleItemTitle;
              let self = this;
              this.$data.newExampleItemTitle = '';
              updateGood(newItem)
            .then(function(data) {
              if(data.success == true) {
                self.$data.exampleItems.push(data.item);
              } else {
                showDialog(data.message);
              }
            })
            .catch(function(err) {
              let msg = err;
              if(err.response != undefined) {
                msg += ' (' + err.response + ')';
              }
              showDialog(msg);
            })
          },

          getLocationItems: function() {
            let self = this;
            getGoods("location", 0, "pos")
            .then(function(data) {
              if(data.success == true) {
                self.$data.locations = data.item;
              }
            })
          },
          updateLocationOrder: function() {

            let self = this;
            for(let i = 0 ; i < this.$data.locations.length ; i++) {
              this.$data.locations[i].pos = i;
            }
            updateGoods(this.$data.locations)
            .then(function(data) {
              if(data.success == true) {
                self.$data.locations = data.item;
              } else {
                showDialog(data.message);
              }

            })
            .catch(function(err) {

              let msg = err;
              if(err.response != undefined) {
                msg += ' (' + err.response + ')';
              }
              showDialog(msg, "ERROR");
            })
          },

          addNewLocationItem: function() {
            let item = createNewGoodItem(0, "location");
            if(this.$data.locations.length > 0) {
              item.pos = this.$data.locations.length - 1;
            }

            this.$data.locations.push(item);
          },
          updateLocationItem: function(index) {
            let isNew = false;
            if(this.$data.locations[index].id == 0) {
              isNew = true;
            }
            let self = this;
            updateGood(this.$data.locations[index])
            .then(function(data) {
              if(data.success == true) {
                self.$data.locations.splice(index, 1, data.item);
              } else {

              }
            })
            .catch(function(err) {
              let msg = err;
              if(err.response != undefined) {
                msg += ' (' + err.response +')';
              }
              showDialog(msg, "ERROR");
            })
          },
          removeLocationGood: function(index, tag) {
            for(let i = 0 ; i < this.$data.locations[index].tags.length ; i++) {
              if (this.$data.locations[index].tags[i] === tag) {
                this.$data.locations[index].tags.splice(i, 1);
                break;
              }
            }
            this.updateLocationItem(index);

          },
          addLocationGood: function(index) {
            let val = document.getElementById("location-goods-input-" + index).value;
            if(val === null || val === '' || val.length === 0) {
              return;
            }

            let found = false;
            for(let i = 0 ; i < this.$data.locations[index].tags.length ; i++) {
              if(this.$data.locations[index].tags[i] === val) {
                //found already
                found = true;
                break;
              }
            }

            if(found === false) {
              this.$data.locations[index].tags.push(val);
            }
            document.getElementById("location-goods-input-" + index).value = "";

            this.updateLocationItem(index);


          },
          deleteLocationItem: function(index) {
            if(this.$data.locations[index].id == 0) {
              this.$data.locations.splice(index, 1);
              return;
            }

            let self = this;
            deleteGood(this.$data.locations[index].id)
            .then(function(data) {
              if(data.success == true) {
                self.$data.locations.splice(index, 1);
              } else {
                showDialog(data.message);
              }
            })
            .catch(function(err){
              let msg = err;
              if(err.resppnse != undefined) {
                msg += ' (' + err.response +')';
              }
              showDialog(msg);
            })

          },
          getPrepItems: function() {
            let self = this;
            getGoods("preparation_example", 0, "pos")
              .then(function(data) {
                if(data.success == true) {
                  self.$data.preparations = data.item;
                }
              })
          },
          updatePrepOrder: function() {

            let self = this;
            for(let i = 0 ; i < this.$data.preparations.length ; i++) {
              this.$data.preparations[i].pos = i;
            }
            updateGoods(this.$data.preparations)
              .then(function(data) {
                if(data.success == true) {
                  self.$data.preparations = data.item;
                } else {
                  showDialog(data.message);
                }

              })
              .catch(function(err) {

                let msg = err;
                if(err.response != undefined) {
                  msg += ' (' + err.response + ')';
                }
                showDialog(msg, "ERROR");
              })
          },

          addNewPrepItem: function() {
            let item = createNewGoodItem(0, "preparation_example");
            if(this.$data.preparations.length > 0) {
              item.pos = this.$data.preparations.length - 1;
            }

            this.$data.preparations.push(item);
          },
          updatePrepItem: function(index) {
            let isNew = false;
            if(this.$data.preparations[index].id == 0) {
              isNew = true;
            }
            let self = this;
            updateGood(this.$data.preparations[index])
              .then(function(data) {
                if(data.success == true) {
                  self.$data.preparations.splice(index, 1, data.item);
                } else {

                }
              })
              .catch(function(err) {
                let msg = err;
                if(err.response != undefined) {
                  msg += ' (' + err.response +')';
                }
                showDialog(msg, "ERROR");
              })
          },
          deletePrepItem: function(index) {
            if(this.$data.preparations[index].id == 0) {
              this.$data.preparations.splice(index, 1);
              return;
            }

            let self = this;
            deleteGood(this.$data.preparations[index].id)
              .then(function(data) {
                if(data.success == true) {
                  self.$data.preparations.splice(index, 1);
                } else {
                  showDialog(data.message);
                }
              })
              .catch(function(err){
                let msg = err;
                if(err.resppnse != undefined) {
                  msg += ' (' + err.response +')';
                }
                showDialog(msg);
              })

          },



          deleteUser: function(user) {
              let self = this;
            this.$modal.show('dialog',{
              title: "Delete User",
              text: "Are you sure to delete " + user.name + " (" + user.email + ")?",
              buttons:[
                {
                  title:'No',
                  handler: () => {
                    self.$modal.hide('dialog');

                  }
                },
                {
                  title: 'Delete',
                  handler:()=>{
                    self.onDeleteUserConfirmed(user);
                    self.$modal.hide('dialog');
                  }
                }
              ]
            })
          },
          onDeleteUserConfirmed: function(user) {

              let self = this;
            deleteUser(user.id)
              .then(function(data) {
                if(data.success === true) {
                  self.$data.editUser = false;
                  for(let i = 0 ; i < self.$data.users.length ; i++) {
                    if(self.$data.users[i].id === data.item.id) {
                      self.$data.users.splice(i, 1);
                      return;
                    }
                  }
                }
              })
              .catch(function(err) {
                console.log(err);
                if(err.response !== undefined) {
                  console.log(err.response);
                }
              })
          },
          editUserItem: function(id = 0) {
            if(id == 0) {
              this.$data.editUser = createNewUser();
            } else {
              let self = this;
              getUser(id)
                .then(function(data) {
                  // if(data.success == true) {
                    self.$data.editUser = data;
                  // } else {
                  //   showDialog(data.message);
                  // }
                })
                .catch(function(err) {
                  showDialog("Error " + err);
                })

            }
          },

          submitEditUser: function() {
            if(this.$data.editUser.id == 0) {
              // Check password matching
              if(this.$data.editUser.password == null || this.$data.editUser.password.length < 4) {
                showDialog("Please enter password");
                return;
              }

              if(this.$data.editUser.password !== this.$data.editUser.password2) {
                showDialog("Passwords are not matching", "Password error");
                return;
              }
            } else if(this.$data.editUser.password != null && this.$data.editUser.password.length > 0 && this.$data.editUser.password !== this.$data.editUser.password2) {
              showDialog("Passwords are not matching", "Password error");
              return;
            }

            if(this.$data.editUser.name == null || this.$data.editUser.name.length == 0) {
              showDialog("Please enter name of user");
              return;
            }

            if(this.$data.editUser.email == null || this.$data.editUser.email.length == 0) {
              showDialog("Please enter user email");
              return;
            }

            let self = this;

            updateUser(this.$data.editUser)
              .then(function(data) {
                if(data.success == true) {

                  for(let i = 0 ; i < self.$data.users.length ; i++) {
                    if(self.$data.users[i].id == data.item.id) {
                      self.$data.users.splice(i, 1, data.item);
                      self.$data.editUser = false;
                      return;
                    }
                  }
                  self.$data.users.push(data.item);
                  self.$data.editUser = false;
                } else {
                  showDialog("Failed to update " + data.message);
                }
              })
              .catch(function(err) {
                showDialog("Error occurred " + err);
              })
          },
          getCompanyInfo: function() {
            let self = this;
            getMainAgent()
              .then(function(data) {
                if(data.success == true) {
                  data.item.edit = false;
                  self.$data.agent = data.item;
                }
              })
              .catch(function(err) {

              })
          },
          saveCompanyInfo: function() {
            let self = this;
            updateAgent(this.$data.agent)
              .then(function(data) {
                if(data.success === true) {
                  data.item.edit = false;
                  self.$data.agent = data.item;
                } else {
                  showDialog(data.message);
                }
              })
          },

          onDocumentUploadClicked: function(ref) {
            let inputView = document.getElementById(ref);
            console.log('upload ' + ref);
            console.log(inputView);
            inputView.value = "";
            inputView.click();
          },
          openDocument: function(url) {
            window.open(url, '_blank').focus();
          },



        }
    }
</script>

<style scoped>
  .form-container {
    position: absolute;
    background: rgba(0,0,0,0.4);
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 998;
  }
  .form-inner-container {
    position: absolute;
    width: 80%;
    max-width: 700px;
    height: 80%;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    background: white;
    padding:50px;
    padding-bottom:70px;
    overflow-y: scroll;
  }
  .form-button-container {
    position: sticky;
    bottom:-70px;
    left: 0;
    width: 100%;
    padding:20px;
    background: white;
  }
  label.form-control {
    border:none;
  }
  .image-container {
    margin-bottom: 30px;
  }
  .image-container > img {
    max-width: 95%;
    max-height: 95%;
  }
  .image-input-container {
    position: fixed;
    bottom:20px;
    left:20px;
    width: 100px;
    height: 100px;
    border:3px solid gray;
  }



  .admin-unchecked {
    color:grey;
  }
  .admin-checked {
    color:blue;
  }
  .form-table tr td {
    padding-top: 10px;
  }
  .form-table tr td:nth-child(1) {
    text-align: right;
    padding-right: 10px;

  }
  .form-table-row td {
    padding-top: 10px;
  }

  tbody::before
  {
    content: '';
    display: table-row;
    height: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Setting.vue